import React from 'react'
import { useDraggableSheet } from '../../../helpers/hooks';
import './PriceDetails.scss';
import Icon from '../Icon/Icon';
import { calculateFullPrice } from '../../../helpers/money';

const PriceDetailsAddCreation = ({ onClose, price }) => {
    const {
        // dragOffset,
        // dragging,
        sheetStyle,
        overlayHandlers
    } = useDraggableSheet({ onClose });
    // Calculate fees based on creation.price
    const basePrice = parseFloat(price) || 0;
    const fullAmount = calculateFullPrice(basePrice)?.totalAmount

    return (
        <div
            className="about-creator "
            {...overlayHandlers}
        >
            <div
                className={`sheet p-24`}
                style={{ ...sheetStyle }}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="price-details-modal">
                    
                    <>
                        <p className="modal-title ta-center fs-real fw-bold fg-dark mb-24 mt-0">Price details</p>

                        <div className="breakdown-section mb-24">
                            <p className="breakdown-title fw-bold fg-dark mb-16">Breakdown</p>
                            <div className="price-breakdown">
                                <div className="price-row d-flex aic mb-12 fg-pink">
                                    <span className="price-label fw-medium">Your price</span>
                                    <span className="price-amount ml-auto">€ {basePrice.toFixed(2)}</span>
                                </div>
                                <div className="price-row d-flex aic mb-12 fg-pink  ">
                                    <span className="price-label fw-medium">+ HYK fees (10%)</span>
                                    <span className="price-amount ml-auto">€ {calculateFullPrice(basePrice)?.hykFee?.toFixed(2)}</span>
                                </div>
                                <div className="price-row d-flex aic mb-12 fg-pink fw-medium">
                                    <span className="price-label fw-medium">+ Stripe fees (1,5%+ € 0,25)</span>
                                    <span className="price-amount ml-auto">€ {calculateFullPrice(basePrice)?.stripeFee?.toFixed(2)}</span>
                                </div>
                                <div className="price-row fg-pink fw-bold total-row d-flex aic">
                                    <span className="price-label">= Full price</span>
                                    {console.log(fullAmount)}
                                    <span className="price-amount ml-auto">€ { fullAmount? fullAmount:0}</span>
                                </div>
                            </div>
                        </div>

                        <div className="fees-explanation">
                            <p className="explanation-title fw-bold mb-16">Why am I paying these fees?</p>
                            <div className="explanation-list">
                                <div className="explanation-item d-flex aic mb-12">
                                    <Icon alias="check_outline" stroke="#FF8CDC" color="none" width={24} />
                                    <span className='ml-8 fw-medium'>Keep HYK fair, independent, and free of ads</span>
                                </div>
                                <div className="explanation-item d-flex aic mb-12">
                                    <Icon alias="check_outline" stroke="#FF8CDC" color="none" width={24} />
                                    <span className='ml-8 fw-medium'>Support the creators you care about.</span>
                                </div>
                                <div className="explanation-item d-flex aic mb-12">
                                    <Icon alias="check_outline" stroke="#FF8CDC" color="none" width={24} />
                                    <span className='ml-8 fw-medium'>Pay for our infrastructure costs</span>
                                </div>
                                <div className="explanation-item d-flex aic mb-12">
                                    <Icon alias="check_outline" stroke="#FF8CDC" color="none" width={24} />
                                    <span className='ml-8 fw-medium'>Insure safe payments</span>
                                </div>
                            </div>
                        </div>
                    </>

                </div>
            </div>
        </div>
    )
}

export default PriceDetailsAddCreation